import { useState } from "react";
import { Button } from "@/components/Base/Button";
import { Icon } from "@/components/Common/Icon";
import { IconNames } from "@/types/v2";
import { SoundPreferencesDialog } from "./SoundPreferencesDialog";

interface SoundAlertsSidebarItemProps {
  /** Called when the entry is clicked, so the sidebar can close itself. */
  onOpen: () => void;
  iconClassName: string;
}

/**
 * The sidebar's "Sound alerts" entry: opens the per-user sound settings dialog.
 * Shown to every role.
 * @param {SoundAlertsSidebarItemProps} props - Close callback and icon styling.
 * @returns {JSX.Element} The entry and its dialog.
 */
export const SoundAlertsSidebarItem = ({
  onOpen,
  iconClassName,
}: SoundAlertsSidebarItemProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="ghost-alt"
        onClick={() => {
          onOpen();
          setOpen(true);
        }}
        className="flex flex-row items-center gap-0 pl-0"
      >
        <Icon name={IconNames.bell} className={iconClassName} />
        Sound alerts
      </Button>
      <SoundPreferencesDialog open={open} onOpenChange={setOpen} />
    </>
  );
};
